import React from "react"
import Flag from "react-flagkit"

import Select from "../../../common/Select/Select"
import { COUNTRIES } from "../../../../constants"

const CountryFlagSelect = ({
  placeholder, name, editable, setEditable, showEditButton, editButtonText, value, label, error, onChange, disabled, useCountryName,
}) => {
  const options = COUNTRIES.map((country) => ({
    value: country.code,
    label: useCountryName ? country.name : country.mobileCode,
  }))

  // Custom option component with country flag
  const CustomOption = ({ innerProps, label, value }) => (
    <div {...innerProps}>
      <span className="signup-input__select-option">
        <Flag country={value} />
        {label} ({value})
      </span>
    </div>
  )

  return (
    <Select
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      error={error}
      showEditButton={showEditButton}
      editable={editable}
      setEditable={setEditable}
      options={options}
      editButtonText={editButtonText}
      disabled={disabled}
      label={label}
      optionComponent={CustomOption}
    />
  )
}

export default CountryFlagSelect
